import { useState } from 'react';

import { AlertsLimitsApi } from 'Api/AlertsLimits/AlertsLimitsApi';
import { Alert } from 'Components/Alert/Alert';
import { Button } from 'Components/Buttons/Buttons';
import { Modal } from 'Components/Modal/Modal';
import { Text } from 'Components/Text/Text';
import { ICON_CLOSE, ICON_DELETE_REMOVE } from 'Config/Icons';

import styles from './DeleteLimitModal.module.css';

export interface DeleteLimitModalProps {
    hideModal: () => void;
    deleteLimitTitle: string;
    deleteLimitId: string;
    alertsLimitsApi: AlertsLimitsApi;
    updateLimitListing: () => void;
}

export const DeleteLimitModal = (props: DeleteLimitModalProps) => {
    const [isDeletingLimit, setIsDeletingLimit] = useState(false);
    const [failureMessage, setFailureMessage] = useState<string>();
    const [successMessage, setSuccessMessage] = useState<string>();

    const deleteLimit = async (limitId: string): Promise<void> => {
        setIsDeletingLimit(true);
        setFailureMessage(undefined);
        setSuccessMessage(undefined);
        try {
            await props.alertsLimitsApi.deleteLimit(limitId);
            setSuccessMessage('Limit deleted.');
            props.updateLimitListing();
        } catch (error) {
            handleRequestError(error);
        } finally {
            setIsDeletingLimit(false);
        }
    };

    const handleRequestError = (error: Error): void => {
        setSuccessMessage(undefined);
        setFailureMessage(error.message);
    };

    const hideModal = (): void => {
        if (!isDeletingLimit) {
            props.hideModal();
        }
    };

    return (
        <Modal open header="Delete">
            {successMessage && <Alert type="success">{successMessage}</Alert>}
            {failureMessage && <Alert type="error">{failureMessage}</Alert>}
            <div className={styles.deleteText}>
                <Text>Are you sure you want to delete: {props.deleteLimitTitle}?</Text>
            </div>
            <div className={'modalFormButtonContainer'}>
                <Button variant="secondary" onClick={hideModal} fontAwesomeImage={ICON_CLOSE} disabled={isDeletingLimit}>
                    Close
                </Button>
                <Button variant="danger" onClick={() => deleteLimit(props.deleteLimitId!)} fontAwesomeImage={ICON_DELETE_REMOVE} loadingText={'Deleting...'} isLoading={isDeletingLimit} disabled={successMessage ? true : false}>
                    Delete
                </Button>
            </div>
        </Modal>
    );
};
